<template>
	<div
		:class="[
			'box',
			{
				'box--has-header' : hasHeader,
				'box--has-footer' : hasFooterSlot
			}
		]"
	>
		<div
			v-if="hasHeader"
			class="box__header"
		>
			<div
				v-if="title || icon"
				class="box__header-title-wrapper"
			>
				<helio-icon
					v-if="icon"
					:token="icon.token"
					:weight="icon.weight ? icon.weight : 'regular'"
					:color="icon.color ? icon.color : null"
					class="box__header-icon"
				/>

				<h2
					v-if="title"
					class="box__header-title"
				>
					{{ title }}
				</h2>
			</div>

			<div v-if="hasHeaderSlot">
				<slot name="header" />
			</div>
		</div>

		<div class="box__content">
			<div v-if="!hasLeftSlot && !hasRightSlot">
				<slot />
			</div>

			<div
				v-if="hasLeftSlot"
				class="box__left"
			>
				<slot name="left" />
			</div>

			<div
				v-if="hasRightSlot"
				class="box__right"
			>
				<slot name="right" />
			</div>
		</div>

		<div
			v-if="hasFooterSlot"
			class="box__footer"
		>
			<slot name="footer" />
		</div>
	</div>
</template>

<script>
import Icon from '../icon/Icon.vue';

export default {
	name: 'Box',

	components: {
		'helio-icon': Icon,
	},

	props: {
		icon: {
			type: Object,
			required: false,
			default: null,
			description: 'Sets an icon that will appear next to the title of the Box',
		},

		title: {
			type: String,
			required: false,
			default: null,
			description: 'Sets the title of the Box',
		},
	},

	slots: {
		default: {
			required: false,
			scoped: false,
			description: 'Supplies the contents of the Box\'s full-width main section',
		},

		footer: {
			required: false,
			scoped: false,
			description: 'Supplies the contents of the Box\'s footer',
		},

		header: {
			required: false,
			scoped: false,
			description: 'Supplies the contents of the Box\'s header',
		},

		left: {
			required: false,
			scoped: false,
			description: 'Supplies the contents of the left-hand side of the Box\'s main section',
		},

		right: {
			required: false,
			scoped: false,
			description: 'Supplies the contents of the right-hand side of the Box\'s main section',
		},
	},

	computed: {
		hasHeader() {
			if (this.title || this.icon || this.hasHeaderSlot) {
				return true;
			}

			return false;
		},

		hasHeaderSlot() {
			return !!this.$slots.header || !!this.$scopedSlots.header;
		},

		hasLeftSlot() {
			return !!this.$slots.left || !!this.$scopedSlots.left;
		},

		hasRightSlot() {
			return !!this.$slots.right || !!this.$scopedSlots.right;
		},

		hasFooterSlot() {
			return !!this.$slots.footer || !!this.$scopedSlots.footer;
		},
	},
};
</script>

<style lang="scss" src="./box.scss" />
